"use client";

import { type PropsWithChildren } from "react";
import { useBanner } from "./WorldCupBanner";

export function SiteMain({ children }: PropsWithChildren) {
  const { visible } = useBanner();

  return (
    <main
      className={
        visible
          ? "pt-[168px] lg:pt-[232px] xl:pt-[264px]"
          : "pt-32 lg:pt-48 xl:pt-56"
      }
    >
      {children}
    </main>
  );
}
